/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../base.model';

export class ParentFacilityDto extends BaseModel {
  /** Remark: For facilities loaded from Viewpoint-api the ParentFacilityID === VPParentFacilityKeyID */
  public ParentFacilityID: number;
  public ParentCustomerID: number;
  public FacilityName: string;
  public DisplayName: string;
  public Address: string;
  public City: string;
  public State: string;
  public ZIP: string;
  public ParentCustomerName: string;
  public ParentCustomerShortName: string;
  public Subsidiary: string;
  public IndustryID: string;
  public IndustryName: string;
  /** Remark: For facilities loaded from Viewpoint-api the ParentFacilityID === VPParentFacilityKeyID */
  public VPParentFacilityKeyID: number;
  public bActive: boolean;
  public IsUserFavorite: boolean;
  public EndMarket: string;
}
